import React from 'react';

const latestRecipes = [
  {
    id: 1,
    title: '法式香吐司',
    time: '20 分钟',
    rating: '4.8',
    image: 'https://images.unsplash.com/photo-1484723091739-30a097e8f929?w=400&q=80'
  },
  {
    id: 2,
    title: '凯撒沙拉',
    time: '15 分钟',
    rating: '4.7',
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400&q=80'
  },
  {
    id: 3,
    title: '意式提拉米苏',
    time: '30 分钟',
    rating: '4.9',
    image: 'https://images.unsplash.com/photo-1624353365286-3f8d62daad51?w=400&q=80'
  },
  {
    id: 4,
    title: '草莓奶油蛋糕',
    time: '90 分钟',
    rating: '4.8',
    image: 'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=400&q=80'
  }
];

const Latest = () => {
  return (
    <section className="latest">
      <div className="container">
        <div className="section-header">
          <h2>最新食谱</h2>
          <p>为你的厨房带来新鲜灵感</p>
        </div>
        <div className="latest-grid">
          {latestRecipes.map((recipe) => (
            <a href="#" className="latest-card" key={recipe.id}>
              <div className="latest-image">
                <img src={recipe.image} alt={recipe.title} />
              </div>
              <div className="latest-content">
                <h4>{recipe.title}</h4>
                <div className="latest-meta">
                  <span>{recipe.time}</span>
                  <span>{recipe.rating}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Latest;
